import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Grid, Column, Row, Button, cls, HeaderCompound, TransactionTitle } from 'packages/components';
import { PAYMENT_METHOD_SELECT } from '../utils/constants';
import { connect } from 'react-redux';
import Assets from '../../requests/apa/Asset';
import { autobind } from 'packages/core/lib';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Device from '../../devices/device';
import Translator from '../../requests/apa/Translator';
import Asset from "../../requests/apa/Asset";
import { getWorkflow } from '../utils/Utils';
import { showModal, AAF_MODAL_TEXLMEX_ACTIVATE, AAF_MODAL_CHANGE_PAYMENT_METHOD } from '../../actions/modal';
import './_styles.scss';
import { setMetricsEvent } from '../../actions/metrics';
import Utils from '../../utils/Utils';
import { METODO_DE_PAGO,COMPONENT_PLAN_SELECTOR, LABER_CANCELAR_MEDIO_DE_PAGO, EVENT_ACTION_METODO_DE_PAGO } from '../../packages/components/lib/utils/constants';
import {applyOutLineFocus} from "../../components/Focus/utils";

interface IPaymentState {
    worflowstart: any;
    pbi: any;
    type: number;
    selectedGateway: string
}

interface IButtonProps {
    id?: string
}

class Payments extends Component<RouteComponentProps, IPaymentState> {
    public title: string = Translator.get('paymentSelector_addPayment_title_label', 'Agregar medio de pago');
    public titleChange: string = Translator.get('paymentSelector_changePayment_title_label', 'Cambiar medio de pago');
    public subTitle: string = Translator.get('top_head_step_2_3_label', 'PASO 2 DE 3');
    public textCancel: string = Translator.get('paymentSelector_access_option_button_cancel', 'CANCELAR');
    public textBack: string = Translator.get('top_head_option_button_back', 'REGRESAR');
    public logoUrl: string = Assets.get('logo_clarotv', '');
    public logoMetadata: string = Translator.get('landing_head_logoClarovideo', this.logoUrl);
    public iconReturn: string = Asset.get('top_head_option_back');
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    public dataLength: number = 0;
    public image: string = '';
    private from: string = '';

    constructor(props: RouteComponentProps) {
        super(props);
        const { location: { state = {} } = {} } = props || {};
        this.from = state?.from;
        this.state = {
            worflowstart: {},
            pbi: {},
            type: 0,
            selectedGateway: '',
        };
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
    }

    public componentDidMount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        const { location: { state: { type, pbi, worflowstart } } } = this.props;
        if (worflowstart && pbi && type) {
            this.dataLength = worflowstart.list.length;
            this.setState({ worflowstart, pbi, type });
        }
        if (window.SpatialNavigation && typeof window.SpatialNavigation.focus === 'function')
            setTimeout(() => window.SpatialNavigation.focus('#first-payment-method'), 100);
    }

    @autobind
    private handleBack(): void {
        const { history } = this.props;
        history.goBack();
    }

    @autobind
    private handleCancel(): void {
        const { history } = this.props;
        Utils.sendMetric(this.props,EVENT_ACTION_METODO_DE_PAGO,LABER_CANCELAR_MEDIO_DE_PAGO, METODO_DE_PAGO )
        history.goBack();
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleBack();
        }
    }

    @autobind
    private onFocus(type: string): void {
        this.setState({ selectedGateway: type });
    }

    @autobind
    private onBlur(type: string): void {
        const { selectedGateway } = this.state;
        if (selectedGateway === type) {
            this.setState({ selectedGateway: '' });
        }
    }

    private handleRedirect(method: string): void {
        const { pbi, worflowstart, type } = this.state;
        const {history, showModal, location: { state: { changeMethod, location } } } = this.props;
        const wfs = getWorkflow(method, worflowstart);
        const { paymentMethodData: { account } } = wfs;
        const methodDescription = worflowstart.list.find(list => list.gateway === method);
        const metricsHistory = this.props.location.state.metricsHistory;
        Utils.sendMetric(this.props, EVENT_ACTION_METODO_DE_PAGO , methodDescription.gatewaytext.toLocaleLowerCase(), METODO_DE_PAGO )
        if(worflowstart.contentInfo !== undefined)
            Utils.sendMetric(this.props, `${pbi.oneofferdesc} - ${method}`,worflowstart.contentInfo.contentOriginalTitle, COMPONENT_PLAN_SELECTOR )
        let modal = {
            modalType: '',
            modalProps: {}
        }
        const originMethod = method;
        const trial = location.state.trial !== undefined ? location.state.trial : '';

        const { hasSavedPayway, selectedPaymentMethod = null } = worflowstart || {};
        // Si EL METOO DE PAGO POR DEFAULT ES IGUAL AL METODO SELECCIONADO, REGRESA A LA PANTALLA DE COMPRA.
        if (selectedPaymentMethod && selectedPaymentMethod === method) {
            //TODO revisar si este push resuelve el caso de claro fibra argentina o cualquiera que se le parezca
            history.push(`/detailtransaction`, { ...pbi, newMethod: '' });
            return;
        }
        // Si se selecciona cambio de medio de pago y se tienen datos en el account se lanza modal de cambio de medio de pago
        if (hasSavedPayway && account && selectedPaymentMethod !== method) {
            modal = {
                ...modal,
                modalType: AAF_MODAL_CHANGE_PAYMENT_METHOD,
                modalProps: {
                    data: { account, back: this.handleBack },
                    callback: () => {
                        history.push(`/detailtransaction`, { ...pbi, newMethod: method });
                    }
                }
            }
            return showModal(modal);
        }
        if (method === 'telmexmexicogate') {
            modal = {
                modalType: AAF_MODAL_TEXLMEX_ACTIVATE,
                modalProps: {
                    data: { account, back: this.handleBack },
                    callback: () => { }
                }
            };
            return showModal(modal);
        } else {
            method = wfs?.gateway === 'hubfacturafijagate' || wfs?.gateway === 'hubcorporativofijogate' ? 'hubbidirectional' : method;
            history.push(`/payment-${method}`, { pbi, worflowstart, method, originMethod, type, changeMethod, from: this.from ,trial, metricsHistory});
            return
        }
    }

  public render(): JSX.Element {
        const { worflowstart, selectedGateway, worflowstart: { hasSavedPayway } } = this.state;
        const region = DeviceStorage.getItem('region');
        const classOutLineFocus = applyOutLineFocus()
        return (
            <Grid className={Device.getDevice().getPlatform()}>
                {
                    <HeaderCompound
                        disabled
                        align='right'
                        onClick={this.handleBack}
                        image={this.logoMetadata}
                        textBack={this.textBack}
                        icon={this.iconReturn}
                    />
                }
                <TransactionTitle
                    title={worflowstart.hasSavedPayway ? this.titleChange : this.title}
                    textStep={this.from && this.from === 'plan-selector' ? this.subTitle : ''}
                    className={`${PAYMENT_METHOD_SELECT}-title`}
                />
                <Row className={`${PAYMENT_METHOD_SELECT}-content-center`}>

                    {worflowstart &&
                        worflowstart.list &&
                        worflowstart.list.map((l: any, index: number) => {
                            const { gateway = '', paymentMethodData } = l;
                            let { paymentMethodData: { account } } = l;
                            if (paymentMethodData.cardsData && paymentMethodData.cardsData.length > 0) {
                                account = paymentMethodData.cardsData[0].pan;
                            }
                            if(account && account.length > 4){
                               account = account.slice(account.length-8, account.length)
                            }
                            gateway === selectedGateway ?
                                this.image = Assets.get(`${region}_paymentSelector_access_icon_${gateway}_focus`) :
                                this.image = Assets.get(`${region}_paymentSelector_access_icon_${gateway}`);
                            const buttonProps: IButtonProps = {
                                id: 'first-payment-method'
                            }
                            if (index !== 0) {
                                delete buttonProps.id;
                            }
                            return (
                                <Column lg={12 / this.dataLength} key={l.gateway} className={`${PAYMENT_METHOD_SELECT}-content-center-buttons`}>
                                    <Button
                                        {...buttonProps}
                                        id={index !== 0 ? `paymentmethod-button-${l.gateway}`: 'first-payment-method'}
                                        activate
                                        type="button"
                                        variant="default"
                                        className={cls(
                                            `${l.gateway}`,
                                            `focusable`,
                                            `${PAYMENT_METHOD_SELECT}-button-${l.gateway}`,
                                            `${classOutLineFocus}`,
                                        )}
                                        onClick={() => this.handleRedirect(l.gateway)}
                                        onFocus={() => this.onFocus(l.gateway)}
                                        onBlur={() => this.onBlur(l.gateway)}
                                    >
                                        {<img src={this.image} alt={l.gateway} />}
                                        {hasSavedPayway && <span>{
                                            account ? account : Translator.get('planSelector_withoutAssociated_gateway_label', 'AGREGAR')}</span>
                                        }
                                    </Button>
                                </Column>
                            );
                        })}
                </Row>
                <Row className={`${PAYMENT_METHOD_SELECT}-content-center-cancel`}>
                    <Column lg={12}>
                        <Button
                            activate
                            type="button"
                            className={cls(`focusable`, `${PAYMENT_METHOD_SELECT}-button-cancel`)}
                            onClick={this.handleCancel}
                        >
                            {this.textCancel}
                        </Button>
                    </Column>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal, setMetricsEvent
};

export default connect(null, mapDispatchToProps)(Payments);



// WEBPACK FOOTER //
// ./src/payments/PaymentMethods/index.tsx